import { render } from "./PdfPreview.vue?vue&type=template&id=af9f9b66&scoped=true&ts=true"
import script from "./PdfPreview.ts?vue&type=script&lang=ts"
export * from "./PdfPreview.ts?vue&type=script&lang=ts"

import "./PdfPreview.css?vue&type=style&index=0&id=af9f9b66&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af9f9b66"]])

export default __exports__